import { FolderTreeNode } from './../../model/tree/folder-tree-node';
import { Injectable } from '@angular/core';
import { QuestionFolder } from '../../model';


@Injectable()
export class NecFolderTreeService {
  constructor() {

  }

  /**
   * è·åæä»¶å¤¹æ 
   * @param folders æä»¶å¤¹
   */
  getFolderTree(folders: QuestionFolder[]): FolderTreeNode[] {
    let tree: FolderTreeNode[] = [];
    folders.forEach(folder => {
      if (!folder.parentId || folder.parentId < 1) {
        tree.push(new FolderTreeNode(folder));
      }
    });
    tree.forEach(treeItem => this.packageFolderTree(folders, treeItem));
    return tree;
  }

  /**
   * ç»è£æ 
   * @param folders è¢«æ±ç¶çæä»¶å¤¹
   * @param node æ èç¹
   */
  private packageFolderTree(folders: QuestionFolder[], node: FolderTreeNode) {
    folders.forEach(folder => {
      if (folder.parentId === node.data.id) {
        node.children.push(new FolderTreeNode(folder));
      }
    });
    if (node.children.length > 0) {
      node.children.forEach(treeItem => this.packageFolderTree(folders, treeItem));
    }
  }


  /**
   * è·åæäºèç¹å¨èç¹æ ç§ææçå­èç¹ åå«èªå·±
   * @param folders èç¹éå
   * @param tree æ 
   */
  getAllChildFolders(folders: FolderTreeNode[], tree: FolderTreeNode[]): FolderTreeNode[] {
    let allfolders = [...folders];
    tree.forEach(treeItem => {
      if (allfolders.find(folder => folder.data.id === treeItem.data.parentId)) {
        allfolders.push(treeItem);
      }
      if (treeItem.children && treeItem.children.length > 0) {
        allfolders = this.getAllChildFolders(allfolders, treeItem.children);
      }
    });
    return allfolders;
  }

  /**
   * éè¿æä»¶å¤¹idè·åæä»¶å¤¹æ ä¸­çèç¹
   */
  getFolderNodesByFolderIds(folderIds: number[], tree: FolderTreeNode[]): FolderTreeNode[] {
    let folders: FolderTreeNode[] = [];
    this.appendFolders(folderIds, tree, folders);
    return folders;
  }

  /**
   * æ·»å æ ç§ folderIds å­èç¹çç»æå°foldersä¸­
   * @param folderIds æä»¶å¤¹id
   * @param tree  æ 
   * @param folders æä»¶å¤¹
   */
  private appendFolders(folderIds: number[], tree: FolderTreeNode[], folders: FolderTreeNode[]) {
    tree.forEach(treeItem => {
      if (folderIds.indexOf(treeItem.data.id) > -1) {
        folders.push(treeItem);
      }
      if (treeItem.children && treeItem.children.length > 0) {
        this.appendFolders(folderIds, treeItem.children, folders);
      }
    });
  }


  /**
   * è·åæ²¡æç¶èç¹çæä»¶å¤¹id
   * @param folders æä»¶å¤¹
   */
  getNoParentFolders(folders: QuestionFolder[]) {
    let parentIds: number[] = [];
    let parentIdmap = new Map();
    folders.forEach(folder => {
      parentIdmap.set(folder.id, folder);
    });
    folders.forEach(folder => {
      if (!folder.parentId || folder.parentId && !parentIdmap.get(folder.parentId)) {
        parentIds.push(folder.id);
      }
    });
    return parentIds;
  }
}
